(function() {

    'use strict';

    angular.module('app').config(reportingsUrlConfig);

    reportingsUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function reportingsUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/fleets/details/:id', {
            templateUrl: '/templates/pages/fleets/fleet-details.html',
            controller: 'FleetDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'fleets',
                htmlTitle: 'Fleet Management - Fleet Details',
                pageTitle: 'Fleet Management - Fleet Details'
            }
        }).
        when('/fleets/add', {
            templateUrl: '/templates/pages/fleets/fleet-details.html',
            controller: 'FleetDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'fleets',
                htmlTitle: 'Fleet Management - Fleet Details',
                pageTitle: 'Fleet Management - Fleet Details'
            }
        }).
        when('/fleets/vehicle-types', {
            templateUrl: '/templates/pages/fleets/vehicle-types.html',
            controller: 'VehicleTypesController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'vehicle-types',
                htmlTitle: 'Fleet Management - Global Vehicle Types',
                pageTitle: 'Fleet Management - Global Vehicle Types'
            }
        }).
        when('/fleets/vehicle-types/add', {
            templateUrl: '/templates/pages/fleets/vehicle-type-details.html',
            controller: 'VehicleTypeDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'vehicle-types',
                htmlTitle: 'Fleet Management - Vehicle Type Details',
                pageTitle: 'Fleet Management - Vehicle Type Details'
            }
        }).
        when('/fleets/vehicle-types/details/:id', {
            templateUrl: '/templates/pages/fleets/vehicle-type-details.html',
            controller: 'VehicleTypeDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'vehicle-types',
                htmlTitle: 'Fleet Management - Vehicle Type Details',
                pageTitle: 'Fleet Management - Vehicle Type Details'
            }
        }).
        when('/fleets/vehicles', {
            templateUrl: '/templates/pages/fleets/vehicles.html',
            controller: 'VehiclesController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'vehicles',
                htmlTitle: 'Fleet Management - Vehicle Management',
                pageTitle: 'Fleet Management - Vehicle Management'
            }
        }).
        when('/fleets/vehicles/add', {
            templateUrl: '/templates/pages/fleets/vehicle-details.html',
            controller: 'VehicleDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'vehicles',
                customHeader: true,
                htmlTitle: 'Fleet Management - Vehicle  Details',
                pageTitle: 'Fleet Management - Vehicle  Details'
            }
        }).
        when('/fleets/vehicles/details/:id', {
            templateUrl: '/templates/pages/fleets/vehicle-details.html',
            controller: 'VehicleDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'vehicles',
                customHeader: true,
                htmlTitle: 'Fleet Management - Vehicle  Details',
                pageTitle: 'Fleet Management - Vehicle  Details'
            }
        }).
        when('/fleets/driver-groups', {
            templateUrl: '/templates/pages/fleets/driver-groups.html',
            controller: 'DriverGroupsController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'driver-groups',
                htmlTitle: 'Fleet Management - Driver Groups',
                pageTitle: 'Fleet Management - Driver Groups'
            }
        }).
        when('/fleets/driver-groups/add', {
            templateUrl: '/templates/pages/fleets/driver-group-details.html',
            controller: 'DriverGroupDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'driver-groups',
                htmlTitle: 'Fleet Management - Driver Group Details',
                pageTitle: 'Fleet Management - Driver Group Details'
            }
        }).
        when('/fleets/driver-groups/details/:id', {
            templateUrl: '/templates/pages/fleets/driver-group-details.html',
            controller: 'DriverGroupDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'driver-groups',
                htmlTitle: 'Fleet Management - Driver Group Details',
                pageTitle: 'Fleet Management - Driver Group Details'
            }
        }).
        when('/fleets/drivers', {
            templateUrl: '/templates/pages/fleets/drivers.html',
            controller: 'DriversController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'drivers',
                htmlTitle: 'Fleet Management - Driver Management',
                pageTitle: 'Fleet Management - Driver Management'
            }
        }).
        when('/fleets/drivers/add', {
            templateUrl: '/templates/pages/fleets/driver-details.html',
            controller: 'DriverDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'drivers',
                htmlTitle: 'Fleet Management - Driver  Details',
                pageTitle: 'Fleet Management - Driver  Details',
                customHeader: true
            }
        }).
        when('/fleets/drivers/details/:id', {
            templateUrl: '/templates/pages/fleets/driver-details.html',
            controller: 'DriverDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'fleets',
                subParent: 'drivers',
                htmlTitle: 'Fleet Management - Driver  Details',
                pageTitle: 'Fleet Management - Driver  Details',
                customHeader: true
            }
        });

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();


// WEBPACK FOOTER //
// ./js/urls/fleets.js